exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-7e62764e]{color:0;border-radius:50px;background:transparent;overflow:hidden;border:4px solid rgb(0 0 0/15%)}.card-body[data-v-7e62764e]{background:#fff}.card-title[data-v-7e62764e]{font-weight:700;font-size:24px}.more-article[data-v-7e62764e]{border-radius:50px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e62764e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Articles.vue
// module id = 135
// module chunks = 0